import {InviteContactMethod} from '../../enums/invite-contact-method';
import {translations} from '../../i18n/translations';

/**
 * Array with the available invite contact types.
 *
 * Note: The property 'translation' gives the translation path to be used with i18n.
 * Example: t(inviteContactMethods[0].translation)
 * We don't return the translated value, because once set the values won't change.
 * Thus, if the user updates his language on the profile, the values given by this
 * array won't change and translate to the new language set by the user.
 */
export const inviteContactMethods: Array<{translation: string; type: InviteContactMethod}> = [
  {
    translation: translations.invite_contact_methods[InviteContactMethod.Email],
    type: InviteContactMethod.Email,
  },
  {
    translation: translations.invite_contact_methods[InviteContactMethod.MobilePhoneNumber],
    type: InviteContactMethod.MobilePhoneNumber,
  },
];
